<template>
  <div class="hpPage">

      <!-- debug values 
      <div style="position:fixed;top:0px;left:0px;background:red;color:#fff;padding:50px;z-index:100000;width:500px;font-weight:400 !important">
          {{debugVal}}
      </div>-->

      <div class="--py-3xl el-size--large pro-page">        
                
        <div class="--py-3xl">
          <div style="border:solid 0px red;padding-top:0px;min-height:800px;">            

            <section class="hpSection __fixed">
              <hp-logo></hp-logo>
            </section>
            
            <section class="hpSection __fixed" id="videoSection1" v-if="pageLayoutData">
              <hp-herovideo :sectionData = "hpHeroData"></hp-herovideo>
            </section>
            <section v-else class="hpSection __fixed" style="height:100vh;width:100%;background:#202020;">
              <!-- display empty section while loading -->
            </section>

            <!-- v-if="pageLayoutData && pageLayoutData.length>0"  -->
            <section class="hpSection" id="section_products"  v-if="pageLayoutData" >
              <hp-products :sectionData = "hpProductsList"></hp-products>
            </section>
 
            <section class="hpSection" id="section_webinars"  v-if="pageLayoutData">
              <hp-webinars :sectionData = "hpWebinarsData"></hp-webinars>
            </section>

            <section class="hpSection" id="section_cases"  v-if="pageLayoutData">
              <hp-cases :sectionData = "hpCasesData"></hp-cases>
            </section>

            <section class="hpSection" id="section_protips"  v-if="pageLayoutData">
              <hp-protips :sectionData = "hpProTipsData"></hp-protips>
            </section>

            <section class="hpSection" id="section_blog"  v-if="pageLayoutData">
              <hp-collage :sectionData = "hpBlogData"></hp-collage>
            </section>

            <section class="hpSection" >
              <hp-contact></hp-contact>
            </section>

          </div>
        </div>      
      </div>
  </div>
</template>

<script>
    import { splitLines } from "@/utils";
    import { mapState, mapActions, mapGetters } from "vuex";
    //import hpText from './home/hpText2.vue';
    import hpText from './home/hpText3.vue';

    //import hpProducts from './home/hpProducts.vue'; //dark node
    import hpProducts from './home/hpProductsV1.vue'; //bright mode 

    import hpWebinars from "./home/hpWebinars.vue";
    import hpProtips from './home/hpProtips';
    import hpCollage from './home/hpCollage';
    //import hpLogo from './home/hpLogo';
    import hpLogo from './home/hpLogoMinimal';
    import hpContact from './home/hpContact';
    import hpCases from './home/hpCases';
    import hpHero from './home/hpHero';

    //import hpHerocollage from './home/hpHeroCollage';
    import hpHerovideo from './home/hpHeroVideo';

    export default {
    components: { hpLogo,hpHero,hpHerovideo,hpText,hpWebinars, hpProtips,hpCollage,hpProducts ,hpContact,hpCases},
        data() 
        {
            return {
              heroVideoSection:null,
              heroItemsData:[],
              items:null,
              debugVal:'DEBUG',
              __heroData:
              [
                {
                  "title":"",
                  "subtitle":"Tissue-Level Screw-Retained Solution",
                  "url":"https://www.mis-implants.com/products",
                  "img":"https://www.mis-implants.com/img/product-logos/CONNECT.svg",
                  "video":"https://mis-implants.com/upload/home/global/videos/MIS_CONNECT.mp4",
                  "bg":""
                },
                {
                  "title":"",
                  "subtitle":"Join the MIS Community",
                  "url":"https://360.mis-implants.com/",
                  "img":"https://www.mis-implants.com/img/product-logos/palma_logo4.svg",
                  "video":"https://mis-implants.com/upload/home/global/videos/mis_global_conference_palma.mp4",
                  "bg":""
                }  
              ]            
            };
        },
        created()
        {          
          //this.loadHeroItems();
          this.setPageReady(false);
          this.initScrollListener();
          //this.initRouteByPath(`HomeV3/${this.$route.params.locale || "global"}`);


        },
        mounted()
        {
        },
        async mounted()
        {            
            //alert("loading data");
            this.initRouteByPath(`HomeV3/${this.$route.params.locale || "global"}`);
            //this.initPageData();
            //this.resetPageLayout();
            //this.setPageReady(true);
        },
        computed: {
          //...mapGetters(["catalogCategories"]),
          ...mapState(["product_data", "pageReady","pageLayoutData"]),
          _pageLayoutData()
          {
            return this.pageLayoutData;
          },
          pageTitle() {
            return this.pageLayoutData &&
              this.pageLayoutData.meta &&
              this.pageLayoutData.meta.page_title
              ? this.pageLayoutData.meta.page_title
              : "MIS - Dental Implants Technology";
          },
          pageDescription() {
            return this.pageLayoutData &&
              this.pageLayoutData.meta &&
              this.pageLayoutData.meta.meta_description
              ? this.pageLayoutData.meta.meta_description
              : "MIS - Dental Implants Technology";
          },
          pageKeywords() {
            return this.pageLayoutData &&
              this.pageLayoutData.meta &&
              this.pageLayoutData.meta.meta_keywords
              ? this.pageLayoutData.meta.meta_keywords
              : "MIS, dental implants, c1, v3";
          },          
          _heroItems()
          {
              //static file data
              return this.heroItemsData.heroItems;
          },
          ____hpHeroData()
          { 
            //alert("this.heroItemsData.length="+this.heroItemsData.length);
            /*
            if(this.heroItemsData && this.heroItemsData.length>0)
            {
              return [];
              //return this.heroItemsData.hpHeroData;
            }
            else{return [];}
            */
            if(this.pageLayoutData && this.pageLayoutData.length>0)
            {
              const typeSection = this.pageLayoutData.sections.filter( x => x.type == 'hero');
              return typeSection[0];            
            }else{
              return [];
            }
          },
          hpProductsData()
          {
              //if(this.pageLayoutData && this.pageLayoutData.length>0){
                const typeSection = this.pageLayoutData.sections.filter( x => 
                  x.type == 'products'
                );
                return typeSection[0];
              //}else{
                //return [];
              //}
          },
          hpProductsList()
          {
            //if(this.pageLayoutData && this._pageLayoutData.length>0){
              const typeSection = this.pageLayoutData.sections.filter( x => 
                x.type == 'products'
              );
              return typeSection[0];
            //}else{
              //return [];
            //}
          },
          hpWebinarsData()
          {
            //if(this.pageLayoutData && this._pageLayoutData.length>0){
              const typeSection = this.pageLayoutData.sections.filter( x => 
                x.type == 'webinars'
              );
              return typeSection[0];
            //}else{
              //return [];
            //}
          },
          hpHeroData()
          {
              const typeSection = this.pageLayoutData.sections.filter( x => 
                x.type == 'hero'
              );
              return typeSection[0];
          },

          hpCasesData()
          {
            //if(this._pageLayoutData && this._pageLayoutData.length>0){
              const typeSection = this.pageLayoutData.sections.filter( x => 
                x.type == 'clinical-cases'
              );
              return typeSection[0];
            //}else{
              //return [];
            //}
          },
          hpProTipsData()
          {
            //if(this._pageLayoutData && this._pageLayoutData.length>0){
              const typeSection = this.pageLayoutData.sections.filter( x => 
                x.type == 'protips'
              );
              return typeSection[0];
            //}else{
              //return [];
            //}
          },
          hpBlogData()
          {
            //if(this._pageLayoutData && this._pageLayoutData.length>0){
              const typeSection = this.pageLayoutData.sections.filter( x => 
                x.type == 'blog'
              );
              return typeSection[0];
            //}else{
              //return [];
            //}
          },

          getPrductUserURL()
          {
            //return 'https://www.misimplants.qarad.eifu.online/mis/def/?keycode='+this.product_item_data.product.CatalogNo;
          }
        },
        methods: {
            ...mapActions(["initHomepageData","resetPageLayout", "setPageReady","initRouteByPath","setItemToCollect","addItemToCollection"]),            
            updateMeta()
            {
              //Force the header title to update
              try
              {
                const titleEl = document.querySelector('head title');
                titleEl.textContent = this.pageTitle;
                document.querySelector('meta[name="description"]').setAttribute("content", this.pageDescription);
                document.querySelector('meta[name="keywords"]').setAttribute("content", this.pageKeywords);
              }catch{}
            },
            initText()
            {
              var splitBlocks = document.getElementsByClassName('split-text');
              for (var i = 0; i < splitBlocks.length; i++) 
              {
                let originalElement = splitBlocks[i];
                //extract the additional class names from the original element
                //and inject them into the splitted rows
                var injectClasses = originalElement.className;
                injectClasses = injectClasses.replace("split-text", "");

                splitLines(originalElement,injectClasses); 
              }
            },
            async initPageData2()
            {                
              //var hpPath = `HomeV3/${this.$route.params.locale || "global"}`;
              //this.initHomepageData(hpPath);
              //mutation: SET_HP_CONTENT
              this.initRouteByPath(`HomeV3/${this.$route.params.locale || "global"}`);

                //let content = await this.initRouteByPath(this.$route.path);
                //this.product_item_data = content;
            },
            getLinksListTitle()
            {
                return this.localize("learn_more");
            },      
            getImageURL()
            {
              return 'https://www.mis-implants.com/upload/catalog/products/large/'+
                      this.cProData.product.CatalogNo+'.png';
            },
            __initPageData()
            {
              //BYPASS THE UTILS AND LOAD THE DATA FROM SERVER 
              ////////////////////////////////////////////////////////////////////////
              ////////////////////////////////////////////////////////////////////////
              ////////////////////////////////////////////////////////////////////////
              let vm = this;
              var name = `HomeV3/${this.$route.params.locale || "global"}`;      
              let body = JSON.stringify({ name });
              let apiHeaders = { "Content-Type": "application/json" };
              let apiOptions = { body, method: "post" };
              fetch(api, options).then(function(response) 
              {
                  if (response.status !== 200) {
                    throw new Error("Something Went Wrong!");
                  }
                  return response.json();
                })
                .then(function(json) {  

                });
          },

          ////scroll events /////////////////
          ////scroll events /////////////////
          ////scroll events /////////////////
          initScrollListener(){
            window.addEventListener("scroll", this.scrollHandler, false);   
            
            //set the hero video element container
            this.heroVideoSection = document.getElementById("homeHeroVideo1");            
          },    
          scrollHandler() {
            this.checkSectionsView();
          },
          checkSectionsView(){
            var vm=this;
            var reveals = document.querySelectorAll(".hpSection");
            for (var i = 0; i < reveals.length; i++) 
            {
              var windowHeight = window.innerHeight;
              var elementTop = reveals[i].getBoundingClientRect().top;

              if(i<2)
              {
                //check video frame size (clip and corners expending/shrinking)
                let heroEl= document.getElementById("homeHeroVideo1");
                var videoElementTop = heroEl.getBoundingClientRect().top;
                var videoH = heroEl.getBoundingClientRect().height;
                var topRef = videoElementTop/windowHeight;
                var transformRef = 0;                
                var minTop = 0.3;//0.3;
                var maxTop = -0.7;//-0.7;
                var range = minTop - maxTop; // range is 1                
                var inRangeRef = Math.abs(topRef - minTop);
                if(inRangeRef>1)
                {
                  inRangeRef=1;//end of transformation// the video is minimized to it's minimum
                }
                if(inRangeRef<0.1)//if(inRangeRef<0.1)
                {
                  inRangeRef=0;//start the transformtion a bit later while scrolling 
                }

                //this.debugVal = "inRangeRef:"+inRangeRef+" range:"+range + " topRef:"+topRef;                
                transformRef = inRangeRef;//<<final value for transformation
                this.debugVal = "transformRef:"+transformRef;

                //Range of clip: 0%-6.25%, Corners:0px - 40px
                //var clipPathRef = 6.25 * transformRef;
                var clipPathRef = 11 * transformRef;//10
                var clipCornerRef = 40 * transformRef;
                var clipStyle = "clip-path: inset("+clipPathRef+"% round "+clipCornerRef+"px);";
                heroEl.style = clipStyle;



                if(transformRef>0.8)
                {
                  if(heroEl.classList.contains("mini")==false){
                    heroEl.classList.add("mini");//set minimized (hide conntrols)
                  }
                }else{
                  if(heroEl.classList.contains("mini")==true){
                    heroEl.classList.remove("mini");//set maximized (show conntrols)
                  }

                }
              }

              var elementVisible = 350;
              if (elementTop < windowHeight - elementVisible && elementTop>0){
                if(vm.visibleSection != i){
                  vm.visibleSection = i;
                  vm.onSectionVisible(i);
                }
              }
            }
          },
          onSectionVisible(domSectionIndex)
          {
              var vm=this;
              let sectionIndex = domSectionIndex;
              var sectionElement = document.querySelectorAll(".hpSection")[domSectionIndex];
              let sectionDataIndex = sectionIndex;
              vm.updateVideoState(domSectionIndex);   
              //vm.updateVideoStateByScroll();               
              this.revealSectionChildrenElements(sectionElement);
          },

          //--------------------------------------------------------------------------------
          //SET THE STATE OF THE HERO VIDEO ACCORDING TO THE SCROLL POSITION
          //--------------------------------------------------------------------------------
          updateVideoStateByScroll()
          {

          },
          updateVideoState(secIndex)
          {
              var vm=this;
              vm.heroVideoSection = document.getElementById("homeHeroVideo1");

              /*
              if(secIndex>1)
              {                  
                  if(vm.heroVideoSection.classList.contains("mini")==false){
                    vm.heroVideoSection.classList.add("mini");//minimize video
                  }
              }else{                  
                  if(vm.heroVideoSection.classList.contains("mini")==true){
                    vm.heroVideoSection.classList.remove("mini");//expand video
                  }
              }
              */

              var videoElement = document.getElementById("hpVideoPlayer1");
              if(secIndex>2){                
                videoElement.pause();//video is completly hidden (scrolled top), pause the video
              }else{                
                videoElement.play();//video might be visible, play the video 
              }
          },

          //--------------------------------------------------------------------------------
          // REAVEL CHILD ELEMENTS 
          //--------------------------------------------------------------------------------
          revealSectionChildrenElements(parentElement) 
          {
            var vm=this;
            parentElement.classList.add("active");
            var reveals = parentElement.querySelectorAll(".reveal");
            for (var i = 0; i < reveals.length; i++){
                if(reveals[i].classList.contains("active")==false)
                {
                  //vm.onRevealingSection(reveals[i].id);
                  reveals[i].classList.add("active");
                }
            }
          },
          onRevealingSection(sectionID)
          {

          }    
          ////////
        },
        watch: {
            pageLayoutData() 
            {
              var vm =this;
              setTimeout(() => {
                vm.initText();//split the text lines for the reaveling fx
              }, 1000);              
              this.setPageReady(true);
              this.updateMeta();
            },
            locale: {
              deep: true,
              handler() {
                this.initRouteByPath(`HomeV3/${this.$route.params.locale || "global"}`);
              }
            },          
/*           '$route' (to, from) {
            this.resetPageLayout();
            this.initPageData();
            this.setPageReady(true);
          }
 */        }

    }
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
  .hpFont1
  {
      font-size:clamp(0.75rem, 0.8vw, 1.5rem) !important;
  }
  .hpFont15
  {
      font-size:clamp(16px, 1.1vw, 30px) !important;
  }
  .hpFont2
  {
      font-size:clamp(1.2rem, 1.4vw, 2.5rem) !important;
  }
  .hpBold
  {
    font-weight:500 !important;
  }
  .hpSection
  {
    height: auto;
  }
  
/*   //test
  .hpSection:nth-child(2)
  {
    transition: all ease 0.4s;
  }
  .hpSection:nth-child(2).active
  {
    background-color: #000;
  }
 */


  .hpPage
  {
    clear: both;
    /* perspective: 1px; */
    /* background-color: #111; */
  }
  .hpSecTitle
  {
    font-size: 40px;
    letter-spacing: -1.5px !important;
    color: #414141;
    text-transform: uppercase;
    display: block;
    margin: auto;
    text-align: center;
  }
  .hpSecSub
  {
    display: block;
    margin: auto;
    text-align: center;
    width: 100%;
  }
  .hpSecSub a:visited,
  .hpSecSub a
  {
    font-size: 13px;
    color: #444444;
    text-transform: uppercase;
    margin: auto;
    cursor: pointer;
    transition: all ease 0.3s;
    font-weight: 300 !important;
  }
  .hpSecSub a span
  {
    font-weight: 500 !important;
    position: relative;
    color: #1894e2;
  }  
  .hpSecSub a span::after
  {
    content: "";
    height: 2px;
    position:absolute;
    width: 100%;
    border-bottom: solid 1px #1894e2;
    bottom: -5px;
    left: 0px;
    transform: scaleX(0%);
    transition: all ease 0.3s;
  }
  .hpSecSub a:hover span::after
  {
    transform: scaleX(100%);
  }
  .hpSecSub a:hover span
  {
    color: #1894e2;
  }


  .hpPage section
  {
    clear: both;
  }
  .hpSection.fixed
  {
    top: 0px;
    left: 0px;
    position: fixed;
    width: 100vw;
    height: 100vh;
    margin-bottom: 100vh;
  }
  
  /* ----------- mobile ----------- */
  @media screen and (max-width: 815px) {
    .hpSecTitle
    {
      font-size: 30px;
    }
  }

  @media only screen and (min-width:2000px){
      .hpSecSub a,
      .hpSecSub *
      {
        font-size: 0.6vw;
      }
  }


</style>
